import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Text } from '@leroy-merlin-br/backyard-react-ui'

const containerStyles = () => css`
  label: modal__container;

  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`

const highlightedStyles = ({ theme }) => css`
  label: text--highlighted;

  color: ${theme.colors.p500};
`
export const Container = styled('div')(containerStyles)
export const TextHighlight = styled(Text)(highlightedStyles)
